import React, { useState } from 'react';
import FileUploader from './components/FileUploader';
import './App.css';

// Accepts "CCBS-12345" or just "12345", always normalises to "CCBS-12345".
// Returns the normalised value or null if the input is invalid.
function normalizeTicket(raw) {
  const trimmed = raw.trim();
  const fullMatch = trimmed.match(/^CCBS-?(\d+)$/i);
  if (fullMatch) return `CCBS-${fullMatch[1]}`;
  const numOnly = trimmed.match(/^(\d+)$/);
  if (numOnly) return `CCBS-${numOnly[1]}`;
  return null;
}

function App() {
  const [ticketInput, setTicketInput] = useState('');

  const ticketNumber = normalizeTicket(ticketInput);
  const isInvalid = ticketInput.trim().length > 0 && ticketNumber === null;

  return (
    <div className="App">
      <nav className="navbar">
        <a
          className="navbar-logo"
          href="https://vidispine.com"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://vidispine.com/hubfs/Vidispine%20Logos/Logo_Vidispine_Inverted%20colour.svg"
            alt="Vidispine"
          />
        </a>
      </nav>

      <main className="main-content">
        <div className="container">
          <header className="header">
            <h1>Vidispine - DropZone</h1>
            <p>Upload test files for bug analysis - please include your ticket number</p>
          </header>

          <div className="ticket-input-section">
            <label htmlFor="ticketNumber">
              Ticket Number <span className="required">*</span>
            </label>
            <input
              id="ticketNumber"
              type="text"
              value={ticketInput}
              onChange={(e) => setTicketInput(e.target.value)}
              placeholder="e.g., CCBS-12345 or 12345"
              className={`ticket-input${isInvalid ? ' ticket-input-error' : ''}`}
            />
            {isInvalid && (
              <p className="ticket-error">Please enter a valid ticket number (e.g. CCBS-12345 or 12345)</p>
            )}
            {ticketNumber && (
              <p className="ticket-hint">Files will be stored under <strong>{ticketNumber}</strong></p>
            )}
          </div>

          {ticketNumber && (
            <FileUploader ticketNumber={ticketNumber} />
          )}

          {!ticketNumber && !isInvalid && (
            <div className="info-box">
              Please enter your support ticket number above to enable file upload
            </div>
          )}
        </div>
      </main>

      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-copy">
            <span>© {new Date().getFullYear()} Vidispine · Maximized Media Potential</span><br />
            <a href="mailto:hello@vidispine.com">hello@vidispine.com</a>
          </div>
          <div className="footer-impressum">
            <strong>Impressum</strong>
            Vidispine GmbH · Essener Str. 4, Geb. D3 · 22419 Hamburg, Germany<br />
            VAT: DE452957308
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
